module.exports = __webpack_public_path__ + "img/join-07.49c08499.jpg";